import { concat, EMPTY, from, of } from "rxjs";
import { selectCurrentTabId, selectIsModalOpen } from "../../../selectors/selectModalTabId";
import { actionModalCloseAll, actionModalOpen, actionModalTabSelect } from "../../modals/actionModal";
export var createPathSelectTabInModal = function (getModalId, getTabId) { return function (action, state$, deps) {
    var state = state$.value;
    var modalId = getModalId(action, state$, deps);
    var isModalOpen = selectIsModalOpen(state, modalId);
    var openModal$ = isModalOpen
        ? EMPTY
        : from([actionModalCloseAll(), actionModalOpen(modalId)]);
    if (getTabId) {
        var tabId = getTabId(action, state$, deps);
        var isTabSelected = selectCurrentTabId(state) === tabId;
        var selectTab$ = isTabSelected ? EMPTY : of(actionModalTabSelect(tabId));
        return concat(openModal$, selectTab$);
    }
    else {
        return openModal$;
    }
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/createPathSelectTabInModal.ts
// module id = 177
// module chunks = 3